/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Pagination_Gotonext2Inputs */

const id_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke halaman berikutnya`)
};

const ms_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke halaman seterusnya`)
};

const da_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til næste side`)
};

const de_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur nächsten Seite`)
};

const en_us2_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next page`)
};

const es_es2_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la página siguiente`)
};

const es_mx2_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la página siguiente`)
};

const fil_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumunta sa susunod na pahina`)
};

const fr_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à la page suivante`)
};

const it_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla pagina successiva`)
};

const hu_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugrás a következő oldalra`)
};

const nl_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar volgende pagina`)
};

const no_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til neste side`)
};

const pl_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do następnej strony`)
};

const pt_br2_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next page`)
};

const pt_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para a página seguinte`)
};

const ro_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mergi la pagina următoare`)
};

const fi_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry seuraavalle sivulle`)
};

const sv_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till nästa sida`)
};

const vi_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến trang tiếp`)
};

const tr_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki sayfaya git`)
};

const cs_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejít na další stránku`)
};

const bg_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отидете на следваща страница`)
};

const ru_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на следующую страницу`)
};

const uk_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на наступну сторінку`)
};

const ar_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتقل إلى الصفحة التالية`)
};

const hi_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले पृष्ठ पर जाएँ`)
};

const th_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปหน้าถัดไป`)
};

const ja_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のページへ`)
};

const zh_cn2_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next page`)
};

const zh_hant1_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next page`)
};

const ko_table_pagination_gotonext2 = /** @type {(inputs: Table_Pagination_Gotonext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next page`)
};

/**
* | output |
* | --- |
* | "Go to next page" |
*
* @param {Table_Pagination_Gotonext2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_pagination_gotonext2 = /** @type {((inputs?: Table_Pagination_Gotonext2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Pagination_Gotonext2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_pagination_gotonext2(inputs)
	if (locale === "ms") return ms_table_pagination_gotonext2(inputs)
	if (locale === "da") return da_table_pagination_gotonext2(inputs)
	if (locale === "de") return de_table_pagination_gotonext2(inputs)
	if (locale === "en-US") return en_us2_table_pagination_gotonext2(inputs)
	if (locale === "es-ES") return es_es2_table_pagination_gotonext2(inputs)
	if (locale === "es-MX") return es_mx2_table_pagination_gotonext2(inputs)
	if (locale === "fil") return fil_table_pagination_gotonext2(inputs)
	if (locale === "fr") return fr_table_pagination_gotonext2(inputs)
	if (locale === "it") return it_table_pagination_gotonext2(inputs)
	if (locale === "hu") return hu_table_pagination_gotonext2(inputs)
	if (locale === "nl") return nl_table_pagination_gotonext2(inputs)
	if (locale === "no") return no_table_pagination_gotonext2(inputs)
	if (locale === "pl") return pl_table_pagination_gotonext2(inputs)
	if (locale === "pt-BR") return pt_br2_table_pagination_gotonext2(inputs)
	if (locale === "pt") return pt_table_pagination_gotonext2(inputs)
	if (locale === "ro") return ro_table_pagination_gotonext2(inputs)
	if (locale === "fi") return fi_table_pagination_gotonext2(inputs)
	if (locale === "sv") return sv_table_pagination_gotonext2(inputs)
	if (locale === "vi") return vi_table_pagination_gotonext2(inputs)
	if (locale === "tr") return tr_table_pagination_gotonext2(inputs)
	if (locale === "cs") return cs_table_pagination_gotonext2(inputs)
	if (locale === "bg") return bg_table_pagination_gotonext2(inputs)
	if (locale === "ru") return ru_table_pagination_gotonext2(inputs)
	if (locale === "uk") return uk_table_pagination_gotonext2(inputs)
	if (locale === "ar") return ar_table_pagination_gotonext2(inputs)
	if (locale === "hi") return hi_table_pagination_gotonext2(inputs)
	if (locale === "th") return th_table_pagination_gotonext2(inputs)
	if (locale === "ja") return ja_table_pagination_gotonext2(inputs)
	if (locale === "zh-CN") return zh_cn2_table_pagination_gotonext2(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_pagination_gotonext2(inputs)
	return ko_table_pagination_gotonext2(inputs)
});
export { table_pagination_gotonext2 as "table.pagination.goToNext" }